import Marquee from "react-fast-marquee";

const ITEMS = [
  "Removable Prosthodontics",
  "Implant Surgery",
  "Full Mouth Rehabilitation",
  "Smile Designing",
  "Esthetic Restorative",
  "TMJ Management",
  "Maxillofacial Prosthesis",
];

export const MarqueeStrip = () => {
  return (
    <section data-testid="marquee-section" className="bg-emerald py-10 md:py-14 overflow-hidden grain-overlay">
      <Marquee speed={35} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic font-light text-ivory text-4xl md:text-6xl lg:text-7xl px-8">
              {t}
            </span>
            <span className="text-champagne text-3xl md:text-5xl">&bull;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeStrip;
